import { render, staticRenderFns } from "./data-records-widget.vue?vue&type=template&id=6d490892"
import script from "./data-records-widget.vue?vue&type=script&lang=js"
export * from "./data-records-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports